import Vue from "vue";
import Router from "vue-router";
import LandingPage from "@/views/LandingPage/index.vue";
import MainPage from "@/views/MainPage/index.vue";
import HomePage from "@/views/HomePage/index.vue";
import LoginPage from "@/views/LoginPage/index.vue";
import CreatePage from "@/views/CreatePage/index.vue";
import ExamCreate from "@/views/ExamCreate/index.vue";
import EvaluationCreate from "@/views/EvaluationCreate/index.vue";
import MyPage from "@/views/MyPage/index.vue";
import RecyclePage from "@/views/RecyclePage/index.vue";
import DataStatisticsPage from "@/views/DataStatisticsPage/index.vue";
import DataDetail from "@/views/DataStatisticsPage/DataDetail/index.vue";
import DialogDetail from "@/views/DataStatisticsPage/DialogDetail/index.vue";
import LibraryEntry from "@/views/LibraryEntry/index.vue";
import LibraryList from "@/views/LibraryList/index.vue";
import AiCreate from "@/views/AiCreate/index.vue";
import Agreement from "@/views/Agreement/agreement.vue";
import Privacy from "@/views/Agreement/privacy.vue";
import FeiShuLogin from "@/views/FeiShuLogin/index.vue"; // 添加这行代码，导入飞书授权登录组件
import SmsCodePage from "@/views/SmsCodePage/index.vue";
import PersonalCenter from "@/views/PersonalCenter/index.vue";
import PrintPreview from "@/views/PrintPreview/index.vue";

import config from "@/utils/config.js";

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'MainPage',
    //   component: MainPage,
    // children: [
    //   // {
    //   //   path: '/',
    //   //   name: 'HomePage',
    //   //   component: HomePage
    //   // },
    //   // {
    //   //   path: '/create',
    //   //   name: 'CreatePage',
    //   //   component: CreatePage
    //   // },
    //   // {
    //   //   path: '/page1',
    //   //   name: 'Page1',
    //   //   component: Page1
    //   // }
    // ]
    // },
    {
      path: "/",
      name: "LandingPage",
      component: LandingPage,
      meta: {
        showNav: false,
        fullScreen: true,
        title: config.mainTitle,
      },
    },
    {
      path: "/home",
      name: "HomePage",
      component: HomePage,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "问卷模板-" + config.title,
      },
    },
    {
      path: "/create",
      name: "CreatePage",
      component: CreatePage,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "创建问卷-" + config.title,
      },
    },
    {
      path: "/examCreate",
      name: "ExamCreate",
      component: ExamCreate,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "创建考试-" + config.title,
      },
    },
    {
      path: "/evaluationCreate",
      name: "EvaluationCreate",
      component: EvaluationCreate,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "创建测评-" + config.title,
      },
    },
    {
      path: "/login",
      name: "LoginPage",
      component: LoginPage,
      meta: {
        showNav: false,
        fullScreen: true,
        title: "登录-" + config.title,
      },
    },
    {
      path: "/HomePage",
      name: "HomePage",
      component: HomePage,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "问卷模板-" + config.title,
      },
    },
    {
      path: "/MyPage",
      name: "MyPage",
      component: MyPage,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "我的问卷-" + config.title,
      },
    },
    {
      path: "/RecyclePage",
      name: "RecyclePage",
      component: RecyclePage,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "回收站-" + config.title,
      },
    },
    {
      path: "/DataStatisticsPage",
      name: "DataStatisticsPage",
      component: DataStatisticsPage,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "数据统计-" + config.title,
      },
    },
    {
      path: "/DataStatisticsPage/DataDetail",
      name: "DataDetail",
      component: DataDetail,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "数据统计详情-" + config.title,
      },
    },
    {
      path: "/DataStatisticsPage/DialogDetail",
      name: "DialogDetail",
      component: DialogDetail,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "数据统计详情-" + config.title,
      },
    },
    {
      path: "/printPreview",
      name: "PrintPreview",
      component: PrintPreview,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "打印预览-" + config.title,
      },
    },
    {
      path: "/libraryEntry",
      name: "LibraryEntry",
      component: LibraryEntry,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "添加题型-" + config.title,
      },
    },
    {
      path: "/libraryList",
      name: "LibraryList",
      component: LibraryList,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "题库列表-" + config.title,
      },
    },
    {
      path: "/AiCreate",
      name: "AiCreate",
      component: AiCreate,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "AI创建问卷-" + config.title,
      },
    },
    {
      path: "/agreement",
      name: "Agreement",
      component: Agreement,
      meta: {
        title: "服务条款",
        requireAuth: false,
      },
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: Privacy,
      meta: {
        title: "隐私政策",
        requireAuth: false,
      },
    },
    // 添加飞书授权登录路由配置
    {
      path: "/feiShuLogin",
      name: "FeiShuLogin",
      component: FeiShuLogin,
      meta: {
        showNav: false,
        fullScreen: true,
        title: "飞书授权登录",
        requireAuth: false,
      },
    },
    // 添加SMS验证码路由
    {
      path: "/sms/:code",
      name: "SmsCodePage",
      component: SmsCodePage,
      meta: {
        showNav: false,
        fullScreen: true,
        title: "页面跳转中",
        requireAuth: false,
      },
    },
    {
      path: "/PersonalCenter",
      name: "PersonalCenter",
      component: PersonalCenter,
      meta: {
        showNav: true,
        fullScreen: false,
        title: "个人中心-" + config.title,
      },
    },
  ],
  mode: "history",
});



// WEBPACK FOOTER //
// ./src/router/index.js